import { round } from "./common.helpers";

export const getAreaInAcres = (area: number) => {
  return round(area * 100, 3);
};
